<!-- TrainingInstitutionDetail.vue -->
<template>
    <myDialog 
        :isDialog="dialogVisible" 
        :title="title" 
        @handleClose="handleClose"
    >
        <template slot="content">
            <!-- 详情内容区域 -->
            <div class="detail-content" v-if="tableLabel?.length > 0">
                <!-- 基本信息 -->
                <div class="section-container">
                    <myTableSearch 
                    :isOperate="false" 
                    :formData="formData"
                    :tableLabel="tableLabel"
                    :queryFn="queryFn"
                    :queryParams="queryParams"
                    @successQuery="successQuery" 
                    :searchColLg="8" 
                    ref="tableRef" 
                    :isTool="false"
                    :isIndex="true"
                    :isPagination="false">
                    </myTableSearch>
                </div>
            </div>
            
            <!-- 加载状态 -->
            <div v-else-if="loading" class="loading-container">
                <el-skeleton animated>
                    <template #template>
                        <el-skeleton-item variant="text" style="width: 30%" />
                        <el-skeleton-item variant="text" style="width: 40%; margin-left: 24px;" />
                        <el-skeleton-item variant="text" style="width: 35%" />
                    </template>
                </el-skeleton>
            </div>
            
            <!-- 无数据状态 -->
            <div v-else class="no-data">
                <el-empty description="暂无数据" />
            </div>
        </template>
        
        <!-- 底部按钮（可选） -->
        <template slot="footer">
            <div class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
                <!-- 可以添加其他操作按钮 -->
                <!-- <el-button type="primary" @click="handleEdit">编辑</el-button> -->
            </div>
        </template>
    </myDialog>
</template>

<script>
import '@/assets/css/base.css'
import { getTrainingClassStudentType , getTrainingClassStudentSubsidyType , getTrainingClassStudentList } from '@/api/training'
export default {
name: 'Student',
props: {
    isDialog: {
        type: [String, Boolean],
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    classId:{
        type: String,
        default:""
    }
},
data() {
    return {
        dialogVisible: false, // 控制弹窗显示
        loading: false,       // 加载状态
        currentClassId: '', // 当前班级编号（避免直接修改prop）
        institutionInfo: {},
			queryParams: {
                pageNum: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100]
			},
			formData: [
                {
                    label:'补贴类型',
                    type: 'select',
                    key: 'subsidyType',
                    colLg: 8,
                    data: []
                },
                {
                    label:'学员类型',
                    type: 'select',
                    key:'studentType',
                    colLg: 8,
                    data: []
                },
                {
                    label:'姓名/身份证号',
                    type: 'input',
                    key: 'nameOrIdCard',
                    colLg: 8,
                    placeholder: '请输入姓名/身份证号'
                },
			],
			tableLabel: [
                {
                    prop: 'studentRecordId',
                    label: '学员ID',
                    minWidth: 120
                },
                {
                    prop: 'studentName',
                    label: '学员姓名',
                    minWidth: 120
                },
                {
                    prop: 'idCard',
                    label: '身份证号',
                    minWidth: 180
                },
                {
                    prop: 'gender',
                    label: '性别',
                    minWidth: 80
                },
                {
                    prop: 'contactPhone',
                    label: '联系电话',
                    minWidth: 130
                },
                {
                    prop: 'studentType',
                    label: '学员类型',
                    minWidth: 120
                },
                {
                    prop: 'subsidyType',
                    label: '补贴类型',
                    minWidth: 120
                },
                {
                    prop: 'subsidyAmount',
                    label: '补贴金额',
                    minWidth: 120
                },
                {
                    prop: 'subsidyRatio',
                    label: '补贴比例',
                    minWidth: 120
                },
                {
                    prop: 'registrationDate',
                    label: '注册时间',
                    minWidth: 150
                },
			],
    }
},
methods: {
    // 打开弹窗
    openDialog(row) {
        this.dialogVisible = true
        // 优先使用传入的 row 参数中的 classId，如果没有则使用 props
        const id = (row && row.classId) ? row.classId : this.classId
        if (id) {
            this.currentClassId = id
            // 加载下拉选项数据
            this.getTrainingClassStudentType()
            this.getTrainingClassStudentSubsidyType()
            // 加载列表数据
            this.$nextTick(() => {
                if (this.$refs.tableRef) {
                    this.$refs.tableRef.reload()
                }
            })
        } else {
            // 如果没有 id，等待 props 更新后再加载
            this.$nextTick(() => {
                if (this.classId) {
                    this.currentClassId = this.classId
                    this.getTrainingClassStudentType()
                    this.getTrainingClassStudentSubsidyType()
                    if (this.$refs.tableRef) {
                        this.$refs.tableRef.reload()
                    }
                }
            })
        }
    },
    
    // 关闭弹窗
    handleClose() {
        this.dialogVisible = false
        this.detailData = null
        this.currentRowId = null
        // 可以通知父组件弹窗已关闭
        this.$emit('dialog-closed')
    },
    // 获取学员类型
    async getTrainingClassStudentType() {
        try {
            const classId = this.currentClassId || this.classId
            if (!classId) return
            const res = await getTrainingClassStudentType({classId: classId})
            if (res && res.code === 200 && res.data) {
                this.updateFormDataWithSelect('studentType', res.data)
            }
        } catch (error) {
            console.error('加载学员类型失败:', error)
        }
    },
    // 获取补贴类型
    async getTrainingClassStudentSubsidyType() {
        try {
            const classId = this.currentClassId || this.classId
            if (!classId) return
            const res = await getTrainingClassStudentSubsidyType({classId: classId})
            if (res && res.code === 200 && res.data) {
                this.updateFormDataWithSelect('subsidyType', res.data)
            }
        } catch (error) {
            console.error('加载补贴类型失败:', error)
        }
    },
    
  // 获取列表数据
  queryFn(queryParams) {
            const classId = this.currentClassId || this.classId
            if (!classId) {
                console.warn('classId为空，无法加载学员列表')
                return Promise.resolve({ code: 200, data: [] })
            }
            
            // 从 queryParams.query 中提取查询条件（myTableSearch 组件会将表单数据放在 query 中）
            const query = queryParams.query || {}
            
            // 合并 classId 和查询条件到查询参数
            const params = {
                ...query,
                classId: classId,
            }
            
            console.log('最终查询参数:', params)
			return getTrainingClassStudentList(params).then(res => {
                // 处理响应数据格式，不需要分页，直接返回数组
                if (res && res.code === 200 && res.data) {
                    // 如果data是数组，直接返回
                    if (Array.isArray(res.data)) {
                        return {
                            ...res,
                            data: res.data
                        }
                    }
                    // 如果data是对象且有rows属性，返回rows数组
                    if (res.data && typeof res.data === 'object' && !Array.isArray(res.data) && res.data.rows) {
                        return {
                            ...res,
                            data: res.data.rows
                        }
                    }
                }
                return res
            })
		},
    
    // 复制父组件的诚信等级图标方法
    getIntegrityGradeIcon(gradeName) {
        if (!gradeName) return ''
        const upperName = String(gradeName).toUpperCase()
        if (upperName.includes('A')) {
            return 'rankA'
        } else if (upperName.includes('B')) {
            return 'rankB'
        } else if (upperName.includes('C')) {
            return 'rankC'
        }
        return ''
    },
    

    // 更新下拉选项
	updateFormDataWithSelect(key, data) {
        if (!data) return

        const index = this.formData.findIndex(item => item.key === key)
        if (index !== -1) {
            // 判断数据格式：如果是字符串数组，转换为对象数组
            let formattedData = []
            if (Array.isArray(data)) {
                // 检查第一个元素是否是字符串
                if (data.length > 0 && typeof data[0] === 'string') {
                    // 字符串数组格式：["社会化学员培训", "新型学徒制培训", ...]
                    formattedData = data.map(item => ({
                        label: item,
                        value: item,
                        dictLabel: item,
                        dictValue: item
                    }))
                } else {
                    // 对象数组格式
                    formattedData = data.map(item => ({
                        label: item.label || item.name || item.dictLabel || item.value || item,
                        value: item.value || item.dictValue || item.code || item,
                        dictLabel: item.dictLabel || item.label || item.name || item.value || item,
                        dictValue: item.dictValue || item.value || item.code || item
                    }))
                }
            }
            
            // 在数据开头添加"全部"选项
            const dataWithAll = [
                {
                    label: '全部',
                    value: '',
                    dictLabel: '全部',
                    dictValue: ''
                },
                ...formattedData
            ]
            this.$set(this.formData[index], 'data', dataWithAll)
        }
    },
    // 更新总数
    successQuery(e) {
        // 可以在这里处理总数或其他回调数据
        if (e && e.total !== undefined) {
            // 处理总数
        }
    },
},
// 监听父组件传递的isDialog变化（如果使用props控制）
watch: {
    isDialog: {
        handler(newVal) {
            // 如果isDialog是Boolean类型
            if (typeof newVal === 'boolean') {
                this.dialogVisible = newVal
            }
            // 如果isDialog是String类型（例如："true-机构基本信息"）
            else if (typeof newVal === 'string') {
                this.dialogVisible = newVal.includes('true')
            }
        },
        immediate: true
    }
}
}
</script>


<style lang="scss" scoped>
.myDialog {
/deep/ .el-dialog__header {
    height: 48px;
    line-height: 48px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--vt-c-blue)!important;
}
        
/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}
        
/deep/ .el-dialog__headerbtn {
    filter: brightness(0) invert(1) !important;
}
}

.detail-content {
    padding: 20px;

    .section-container {
        margin-bottom: 24px;
        
        &:last-child {
            margin-bottom: 0;
        }
    
        .section-header {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 16px;
            &::before {
            content: '';
            width: 3px;
            height: 12px;
            background: var(--vt-c-blue-soft);
            margin-right: 8px;
        }
        
        &::after {
            content: '';
            flex: 1;
            height: 1px;
            border-top: 1px dashed #d3d4d6;
            margin-left: 8px;
        }
        }
    
        .detail-descriptions {
            /deep/ .el-descriptions__label {
                font-weight: 500;
                color: #606266;
                background: var(--vt-c-grey-mute);
            }
            
            /deep/ .el-descriptions__content {
                color: #303133;
            }
        }

        // 让表格可以左右滚动
        /deep/ .myTableSearch {
            .table {
                overflow-x: auto;
                overflow-y: auto;
            }
            
            /deep/ .el-table {
                min-width: 100%;
            }
            
            // 确保查询条件在一行显示
            .searchCon {
                /deep/ .el-row {
                    flex-wrap: nowrap !important;
                }
                
                /deep/ .el-col {
                    flex-shrink: 0;
                }
            }
        }
    }
}

</style>
